class HOSSectionRules {


    addListeners() {
        const { fields, checkBoxsNames, lookupsNames } = this.getFieldsNames(); 
        const setInitialStateOf = lookup => lookup.disable();

        checkBoxsNames.forEach( (fieldName, index) => {
            const lookup = fields[lookupsNames[index]];
            const checkbox = fields[fieldName];
            setInitialStateOf(lookup);

            checkbox.input.addEventListener("change", (event) => {
                if (event.target.checked) {
                    lookup.enable();
                } else {
                    lookup.clear();
                    lookup.disable();
                }
            });
        });
    };

    getFieldsNames() {
        const fields = App.Forms.Configuration.form.fields;
        const checkBoxsNames = ['startHosOnStartRoute', 'automaticAddLunchStop', 'automaticAddBreakStop'];
        const lookupsNames = ['defaultHoursOfServiceType', 'defaultLunchStopType', 'defaultBreakStopType'];
        
        return {
            fields,
            checkBoxsNames,
            lookupsNames
        }
    };

    checkToEnableLookups() {
        const { fields, lookupsNames } = this.getFieldsNames();

        lookupsNames.forEach( fieldName => {
            const lookup = fields[fieldName];
            !lookup.isEmpty() && lookup.enable();
        });
    };

    checkIfLookupsAreMandatorys() {
        const { fields, checkBoxsNames, lookupsNames } = this.getFieldsNames(); 

        checkBoxsNames.forEach( (fieldName, index) => {
            const lookup = fields[lookupsNames[index]];
            const checkbox = fields[fieldName];

            lookup.setMandatory(false);    
            if (checkbox.getValue()) {
                lookup.setMandatory(true);
            }
        });
    };

};

export default HOSSectionRules;
